import { applyFilters, doRequest } from "./helpers";

export default class MetaSandboxAdService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/sandbox/ads`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
